// src/webrtc/peerConnection.js
import { sendCandidate } from "../socket/signalingClient";

export const createPeerConnection = (roomId, onRemoteStream) => {
  const pc = new RTCPeerConnection({
    iceServers: [
      { urls: "stun:stun.l.google.com:19302" },
      {
        urls: [
          "turn:nukkad.vemeet.online:3479?transport=udp",
          "turn:nukkad.vemeet.online:3479?transport=tcp",
          "turns:nukkad.vemeet.online:5350?transport=tcp",
        ],
        username: "nukkad",
        credential: "MyTurnPass@2025",
      },
    ],
  });

  // Handle remote stream
  pc.ontrack = (event) => {
    console.log("Remote stream received");
    if (onRemoteStream) {
      onRemoteStream(event.streams[0]);
    }
  };

  // ICE Candidates
  pc.onicecandidate = (event) => {
    if (event.candidate) {
      sendCandidate(roomId, event.candidate);
    }
  };

  return pc;
};
